import { Navigate } from 'react-router-dom'
import { isDeveloperMode } from 'utils/isDeveloperMode'

export const DeveloperRouted = (props: { children: React.ReactNode }) => {
  if (isDeveloperMode()) {
    return props.children
  }

  return <Navigate to="/" replace />
}
